import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-8" }
const _hoisted_2 = {
  key: "success",
  class: "text-center py-6"
}
const _hoisted_3 = { class: "text-[2rem] font-bold mb-2 text-[#0f1f2e]" }
const _hoisted_4 = { class: "text-[1.4rem] text-[#627282]" }
const _hoisted_5 = {
  key: 0,
  class: "mt-6 flex flex-col divide-y divide-black/[0.06] border border-black/[0.08] rounded-2xl overflow-hidden text-left"
}
const _hoisted_6 = { key: "create-0" }
const _hoisted_7 = { class: "text-[1.2rem] text-[#9ab4c0] mb-3" }
const _hoisted_8 = { class: "text-[2rem] font-bold mb-1 text-[#0f1f2e]" }
const _hoisted_9 = { class: "text-[1.4rem] text-[#627282] mb-6" }
const _hoisted_10 = { class: "flex flex-col gap-3" }
const _hoisted_11 = { class: "flex-1 min-w-0" }
const _hoisted_12 = { class: "text-[1.5rem] font-semibold text-[#0f1f2e]" }
const _hoisted_13 = { class: "text-[1.3rem] text-[#9ab4c0] mt-0.5 leading-tight" }
const _hoisted_14 = { class: "flex-1 min-w-0" }
const _hoisted_15 = { class: "text-[1.5rem] font-semibold text-[#0f1f2e]" }
const _hoisted_16 = { class: "text-[1.3rem] text-[#9ab4c0] mt-0.5 leading-tight" }
const _hoisted_17 = { key: "create-1-public" }
const _hoisted_18 = { class: "text-[1.2rem] text-[#9ab4c0] mb-3" }
const _hoisted_19 = { class: "text-[2rem] font-bold mb-1 text-[#0f1f2e]" }
const _hoisted_20 = { class: "text-[1.4rem] text-[#627282] mb-5" }
const _hoisted_21 = ["value", "placeholder"]
const _hoisted_22 = { class: "border border-black/10 rounded-[1.6rem] max-h-[220px] overflow-y-auto mb-6" }
const _hoisted_23 = ["onMousedown"]
const _hoisted_24 = {
  key: 0,
  class: "px-[1.6rem] py-[1.6rem] text-[1.4rem] text-[#627282] text-center"
}
const _hoisted_25 = {
  key: 0,
  class: "text-[1.3rem] text-red-500 mt-4"
}
const _hoisted_26 = { class: "flex items-center justify-between mt-6" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { key: "create-1-private" }
const _hoisted_29 = { class: "text-[1.2rem] text-[#9ab4c0] mb-3" }
const _hoisted_30 = { class: "text-[2rem] font-bold mb-1 text-[#0f1f2e]" }
const _hoisted_31 = { class: "text-[1.4rem] text-[#627282] mb-5" }
const _hoisted_32 = { class: "space-y-5" }
const _hoisted_33 = { class: "block text-[1.4rem] font-bold text-black mb-[0.8rem]" }
const _hoisted_34 = ["value", "placeholder"]
const _hoisted_35 = { class: "block text-[1.4rem] font-bold text-black mb-[0.8rem]" }
const _hoisted_36 = { class: "font-normal ml-1 text-[#9ab4c0]" }
const _hoisted_37 = ["value", "placeholder"]
const _hoisted_38 = {
  key: 0,
  class: "text-[1.3rem] text-red-500 mt-4"
}
const _hoisted_39 = { class: "flex items-center justify-between mt-6" }
const _hoisted_40 = ["disabled"]

import type { Disease, Group } from "@/types/domain";
import { useLiveGroups } from "@/components/companionGroups/useLiveGroups";
import PopUp from "@/components/popup/PopUp.vue";

const STEP_SUCCESS = 99;


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateGroupModal',
  props: {
    isOpen: { type: Boolean },
    currentStep: {},
    isSubmitting: { type: Boolean },
    submitError: {},
    isPrivate: { type: Boolean },
    modalDiseaseSearch: {},
    modalSelectedDisease: {},
    filteredModalDiseases: {},
    groupName: {},
    groupDescription: {},
    successTitle: {},
    successMessage: {},
    successMode: {},
    createdGroup: {},
    createdGroupSlug: {},
    groupCreatedCopied: { type: Boolean },
    linkCopied: { type: Boolean }
  },
  emits: ["close", "choose-type", "filter-modal-diseases", "select-modal-disease", "update:groupName", "update:groupDescription", "update:modalDiseaseSearch", "update:currentStep", "submit", "go-to-group", "share-whatsapp", "share-telegram", "copy-invite"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useLiveGroups(
  { _skipInit: true },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  (_e: any, ..._args: any[]) => {},
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopUp, {
    "model-value": __props.isOpen,
    size: "md",
    scrollable: true,
    "show-close-button": true,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = v => !v && emit('close')),
    onClose: _cache[15] || (_cache[15] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: "step-slide",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (__props.currentStep === STEP_SUCCESS)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "w-12 h-12 rounded-full bg-[#2d7a6a]/10 flex items-center justify-center mx-auto mb-4" }, [
                    _createElementVNode("svg", {
                      width: "22",
                      height: "22",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "#2d7a6a",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round"
                    }, [
                      _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                    ])
                  ], -1)),
                  _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.successTitle), 1),
                  _createElementVNode("p", _hoisted_4, _toDisplayString(__props.successMessage), 1),
                  (__props.successMode === 'group')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("button", {
                          class: "flex items-center gap-3 px-5 py-4 hover:bg-slate-50 transition text-[1.4rem] font-semibold text-[#0f1f2e]",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('go-to-group')))
                        }, [
                          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "w-8 h-8 rounded-full bg-[#0f1f2e]/8 flex items-center justify-center flex-shrink-0" }, [
                            _createElementVNode("svg", {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round"
                            }, [
                              _createElementVNode("polyline", { points: "9 18 15 12 9 6" })
                            ])
                          ], -1)),
                          _createTextVNode(" " + _toDisplayString(_unref(t)("goToGroup")), 1)
                        ]),
                        _createElementVNode("button", {
                          class: "flex items-center gap-3 px-5 py-4 hover:bg-slate-50 transition text-[1.4rem] font-semibold text-[#25d366]",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('share-whatsapp')))
                        }, [
                          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "w-8 h-8 rounded-full bg-[#25d366]/10 flex items-center justify-center flex-shrink-0" }, [
                            _createElementVNode("svg", {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "#25d366"
                            }, [
                              _createElementVNode("path", { d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" }),
                              _createElementVNode("path", { d: "M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.118 1.528 5.852L0 24l6.335-1.502A11.936 11.936 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.89 0-3.663-.497-5.2-1.369l-.373-.214-3.762.892.952-3.67-.235-.387A9.937 9.937 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" })
                            ])
                          ], -1)),
                          _createTextVNode(" " + _toDisplayString(_unref(t)("shareWhatsApp")), 1)
                        ]),
                        _createElementVNode("button", {
                          class: "flex items-center gap-3 px-5 py-4 hover:bg-slate-50 transition text-[1.4rem] font-semibold text-[#229ed9]",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('share-telegram')))
                        }, [
                          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "w-8 h-8 rounded-full bg-[#229ed9]/10 flex items-center justify-center flex-shrink-0" }, [
                            _createElementVNode("svg", {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "#229ed9"
                            }, [
                              _createElementVNode("path", { d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12L7.17 13.4l-2.945-.924c-.64-.203-.653-.64.136-.953l11.57-4.461c.537-.194 1.006.131.963.159z" })
                            ])
                          ], -1)),
                          _createTextVNode(" " + _toDisplayString(_unref(t)("shareTelegram")), 1)
                        ]),
                        _createElementVNode("button", {
                          class: "flex items-center gap-3 px-5 py-4 hover:bg-slate-50 transition text-[1.4rem] font-semibold text-[#0f1f2e]",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('copy-invite')))
                        }, [
                          _cache[19] || (_cache[19] = _createElementVNode("span", { class: "w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0" }, [
                            _createElementVNode("svg", {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round"
                            }, [
                              _createElementVNode("rect", {
                                x: "9",
                                y: "9",
                                width: "13",
                                height: "13",
                                rx: "2"
                              }),
                              _createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" })
                            ])
                          ], -1)),
                          _createTextVNode(" " + _toDisplayString(__props.groupCreatedCopied ? _unref(t)("copied") : _unref(t)("shareCopy")), 1)
                        ]),
                        _createElementVNode("button", {
                          class: "flex items-center gap-3 px-5 py-4 hover:bg-slate-50 transition text-[1.4rem] text-[#627282]",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('close')))
                        }, [
                          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center flex-shrink-0" }, [
                            _createElementVNode("svg", {
                              width: "12",
                              height: "12",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round"
                            }, [
                              _createElementVNode("line", {
                                x1: "18",
                                y1: "6",
                                x2: "6",
                                y2: "18"
                              }),
                              _createElementVNode("line", {
                                x1: "6",
                                y1: "6",
                                x2: "18",
                                y2: "18"
                              })
                            ])
                          ], -1)),
                          _createTextVNode(" " + _toDisplayString(_unref(t)("close")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (__props.currentStep === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("stepOf")) + " 1 " + _toDisplayString(_unref(t)("of")) + " 2 ", 1),
                    _createElementVNode("h2", _hoisted_8, _toDisplayString(_unref(t)("chooseTypeTitle")), 1),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)("chooseTypeSubtitle")), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        class: "flex items-center gap-4 p-5 rounded-[1.6rem] border border-black/10 text-left transition-all hover:border-[#0f1f2e] hover:bg-slate-50 group",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('choose-type', false)))
                      }, [
                        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 group-hover:bg-[#0f1f2e] transition-colors" }, [
                          _createElementVNode("svg", {
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            class: "text-[#627282] group-hover:text-white transition-colors"
                          }, [
                            _createElementVNode("circle", {
                              cx: "12",
                              cy: "12",
                              r: "10"
                            }),
                            _createElementVNode("line", {
                              x1: "2",
                              y1: "12",
                              x2: "22",
                              y2: "12"
                            }),
                            _createElementVNode("path", { d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" })
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)("publicGroup")), 1),
                          _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)("publicGroupDesc")), 1)
                        ]),
                        _cache[23] || (_cache[23] = _createElementVNode("svg", {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "#c8d8e0",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          class: "flex-shrink-0"
                        }, [
                          _createElementVNode("polyline", { points: "9 18 15 12 9 6" })
                        ], -1))
                      ]),
                      _createElementVNode("button", {
                        class: "flex items-center gap-4 p-5 rounded-[1.6rem] border border-black/10 text-left transition-all hover:border-[#0f1f2e] hover:bg-slate-50 group",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('choose-type', true)))
                      }, [
                        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0 group-hover:bg-[#0f1f2e] transition-colors" }, [
                          _createElementVNode("svg", {
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            class: "text-[#627282] group-hover:text-white transition-colors"
                          }, [
                            _createElementVNode("rect", {
                              x: "3",
                              y: "11",
                              width: "18",
                              height: "11",
                              rx: "2"
                            }),
                            _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)("privateGroup")), 1),
                          _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)("privateGroupDesc")), 1)
                        ]),
                        _cache[25] || (_cache[25] = _createElementVNode("svg", {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "#c8d8e0",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          class: "flex-shrink-0"
                        }, [
                          _createElementVNode("polyline", { points: "9 18 15 12 9 6" })
                        ], -1))
                      ])
                    ])
                  ]))
                : (__props.currentStep === 1 && !__props.isPrivate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(t)("stepOf")) + " 2 " + _toDisplayString(_unref(t)("of")) + " 2 ", 1),
                      _createElementVNode("h2", _hoisted_19, _toDisplayString(_unref(t)("selectDiseaseTitle")), 1),
                      _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(t)("selectDiseaseSubtitle")), 1),
                      _createElementVNode("input", {
                        ref: "modalDiseaseInputRef",
                        value: __props.modalDiseaseSearch,
                        class: "input border-black/15 focus:border-black/30 mb-3",
                        placeholder: _unref(t)('searchDisease'),
                        onInput: _cache[7] || (_cache[7] = ($event: any) => (emit('filter-modal-diseases', ($event.target as HTMLInputElement).value)))
                      }, null, 40, _hoisted_21),
                      _createElementVNode("div", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filteredModalDiseases, (disease) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: disease.key,
                            class: _normalizeClass(["px-[1.6rem] py-[1rem] cursor-pointer text-[1.4rem] transition-colors", 
                __props.modalSelectedDisease?.key === disease.key
                  ? 'bg-[#0f1f2e] text-white'
                  : 'hover:bg-slate-50'
              ]),
                            onMousedown: _withModifiers(($event: any) => (emit('select-modal-disease', disease)), ["prevent"])
                          }, _toDisplayString(disease.label), 43, _hoisted_23))
                        }), 128)),
                        (__props.filteredModalDiseases.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(t)("noResults")), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (__props.submitError)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(__props.submitError), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("button", {
                          class: "text-[1.4rem] text-[#627282] hover:text-[#0f1f2e] transition flex items-center gap-1.5",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (emit('update:currentStep', 0)))
                        }, [
                          _cache[26] || (_cache[26] = _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5",
                            "stroke-linecap": "round"
                          }, [
                            _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                          ], -1)),
                          _createTextVNode(" " + _toDisplayString(_unref(t)("back")), 1)
                        ]),
                        _createElementVNode("button", {
                          class: "px-[3.2rem] py-[1.2rem] rounded-[10rem] bg-[#0f1f2e] text-white text-[1.4rem] font-semibold disabled:opacity-40 transition hover:opacity-85",
                          disabled: !__props.modalSelectedDisease || __props.isSubmitting,
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (emit('submit')))
                        }, _toDisplayString(_unref(t)("createGroup")), 9, _hoisted_27)
                      ])
                    ]))
                  : (__props.currentStep === 1 && __props.isPrivate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(t)("stepOf")) + " 2 " + _toDisplayString(_unref(t)("of")) + " 2 ", 1),
                        _createElementVNode("h2", _hoisted_30, _toDisplayString(_unref(t)("privateGroup")), 1),
                        _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(t)("privateGroupDesc")), 1),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(t)("groupNameLabel")), 1),
                            _createElementVNode("input", {
                              value: __props.groupName,
                              class: "input border-black/15 focus:border-black/30",
                              placeholder: _unref(t)('groupNamePlaceholder'),
                              onInput: _cache[10] || (_cache[10] = ($event: any) => (emit('update:groupName', ($event.target as HTMLInputElement).value)))
                            }, null, 40, _hoisted_34)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_35, [
                              _createTextVNode(_toDisplayString(_unref(t)("groupDescriptionLabel")) + " ", 1),
                              _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(t)("optional")), 1)
                            ]),
                            _createElementVNode("textarea", {
                              value: __props.groupDescription,
                              rows: "3",
                              class: "textarea border-black/15 focus:border-black/30 h-auto min-h-[10rem]",
                              placeholder: _unref(t)('groupDescriptionPlaceholder'),
                              onInput: _cache[11] || (_cache[11] = ($event: any) => (emit('update:groupDescription', ($event.target as HTMLTextAreaElement).value)))
                            }, null, 40, _hoisted_37)
                          ])
                        ]),
                        (__props.submitError)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(__props.submitError), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("button", {
                            class: "text-[1.4rem] text-[#627282] hover:text-[#0f1f2e] transition flex items-center gap-1.5",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (emit('update:currentStep', 0)))
                          }, [
                            _cache[27] || (_cache[27] = _createElementVNode("svg", {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round"
                            }, [
                              _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(_unref(t)("back")), 1)
                          ]),
                          _createElementVNode("button", {
                            class: "px-[3.2rem] py-[1.2rem] rounded-[10rem] bg-[#0f1f2e] text-white text-[1.4rem] font-semibold disabled:opacity-40 transition hover:opacity-85",
                            disabled: !__props.groupName.trim() || __props.isSubmitting,
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (emit('submit')))
                          }, _toDisplayString(_unref(t)("createGroup")), 9, _hoisted_40)
                        ])
                      ]))
                    : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})